
import { externalMedrep, getCurrentUserRole } from "modules/utilities/utility";
import api from "../../../api"

export function customerFeedbackData() {
  return api.get("get-all-customer-feedback");
}

export function customerFeedbackFilter(sd, ed){
  return api.get(`get-all-customer-feedback?startDate=${sd}&endDate=${ed}`)
}
export function call(callObj) {
  const apiEndpoint= "call";
  return api.post(apiEndpoint, callObj);
}